<header [preLogin]="true"></header>
<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas h-600">
            <grid-row class=" justify-content-center align-content-between h-100">
                <grid-col col="12">
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <div class="font-400 font-size-24px line-h-32 color-base-700">
                                {{ "PleaseLetterWishRequest" | translate }}
                            </div>
                            <div class="form-group mt-20">
                                <label for="">
                                    {{ "TypeLetter" | translate }}
                                </label>
                                <drop-down-list dropDownImage="false" dropDownSearch="false"
                                    [selectedValue]="this.selectedLetter" [dropDownData]="this.LettersList" 
                                    (itemselected)="onLetterChange($event)">
                                    {{this.selectedLetter}}
                                </drop-down-list>
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mt-50">
                        <grid-col col="auto">
                            <div class="mt-15">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </div>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft" [disabled]="this.selectedLetter == '' || this.selectedLetter ==  undefined" (click)="CheckLettersEligibility()">
                                {{ "Next" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>


<modal modalID="16" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONTINUE"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="CheckStatus()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-email-black-big" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"PaymentContinue" | translate}}
        </div>
        <div class="color-base-400  font-size-14px line-h-25 mt-10">
            <span>
                {{ "PaymentsOf" | translate}}
            </span>
            <strong class="color-base-1300">
                {{ "BHD" | translate}} {{this.TotalAmount}} (BHD {{this.PaymentDetail?.charges}} , {{ "vat" | translate}} {{ "BHD" | translate}} {{this.PaymentDetail?.vat}})
            </strong>
            <span>
                {{ "AreRequiredLetter" | translate}}
            </span>
        </div>
    </div>
</modal>
<!-- Change Card -->
<!-- <modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="cancel" (doneButton)="showModal(0)">
    <div class="text-align-center">
        <ng-icon iconClass="icon-card-limit" width="77" height="72"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-25 mt-30 letter-spacing-03">
            {{"SetNewLimit" | translate}}
        </div>
        <div class="mt-10">
            <span class="font-400 line-h-25 color-base-500">
                {{"AreSureWantIncrease" | translate}}
            </span>
            <strong class="color-base-700 line-h-25">
                {{ "BHD" | translate}} 1000,000 ?
            </strong>
            <span class="font-400 line-h-25 color-base-500">
            </span>
        </div>
    </div>
</modal> -->